// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat

export const currencyFormatter = new Intl.NumberFormat('en', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  });


export function formatInputFieldCurrency(event: any) {
    let inputValue = event.target.value
    if (inputValue === "") { return  }

    if (inputValue.indexOf(".") >= 0) {
        const decimalPosition = inputValue.indexOf(".")
        let leftSide = inputValue.substring(0, decimalPosition);
        let rightSide = inputValue.substring(decimalPosition);

        leftSide = leftSide.replace(/^0+/, "");
        leftSide = formatNumber(leftSide);

        rightSide = formatNumber(rightSide);
        rightSide = rightSide.substring(0, 2);
        inputValue = "$" + leftSide + "." + rightSide;
    }else {
      inputValue = formatNumber(inputValue);
      inputValue = "$" + inputValue;
    }

    event.target.value = inputValue;
    return;
}

function formatNumber(n: string) {
  return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

export function parseWager(wager: string): number {
  // Remove non-numeric characters except for the decimal point
  const numericWager = wager.replace(/[^0-9.]/g, '');
  return parseFloat(numericWager);
}